import Modernizr from 'modernizr'

import { EFeatures } from '@hozana/screen/constants'

export const detectFeature = (feature: EFeatures) =>
  // Not strict equal because some values returned are Boolean and not boolean
  __CLIENT__ && Modernizr[feature] == true
